'use client';

import React, { createContext, useContext } from 'react';
import type { StorefrontViewport } from '@/core/utils/viewport';

/**
 * The server's guess of the visitor's viewport (see core/utils/viewport.ts), provided once by the
 * storefront layout so every top-level BlockRenderer on the page — home, CMS pages, category and
 * product templates, cart, login — server-renders the same per-viewport styles the browser will
 * use, instead of each call site defaulting to 'desktop'.
 */
const InitialViewportContext = createContext<StorefrontViewport | null>(null);

export function InitialViewportProvider({ viewport, children }: { viewport: StorefrontViewport; children: React.ReactNode }) {
  return <InitialViewportContext.Provider value={viewport}>{children}</InitialViewportContext.Provider>;
}

export function useInitialViewport(): StorefrontViewport | null {
  return useContext(InitialViewportContext);
}
